// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SupplierCivility from "../Supplier/SupplierCivility.res.js";
import * as OrderSupplierInformationCard__Config__Formatters from "./OrderSupplierInformationCard__Config__Formatters.res.js";

function supplierContactFromData(data) {
  return Stdlib_Option.map(data.contacts.edges.find(param => param.node.isDefault), param => {
    let contact = param.node;
    return {
      formattedName: OrderSupplierInformationCard__Config__Formatters.makeContactName(Stdlib_Option.map(contact.civility, SupplierCivility.toShortLabel), contact.lastName, contact.firstName),
      email: contact.email,
      phoneNumber: contact.phoneNumber,
      mobileNumber: contact.mobileNumber
    };
  });
}

function supplierLocationFromData(data) {
  return Stdlib_Option.map(data.locations.edges[0], param => {
    let location = param.node;
    return {
      recipient: location.recipient,
      address: location.address,
      formattedCity: OrderSupplierInformationCard__Config__Formatters.makeCity(location.postalCode, location.city),
      country: Stdlib_Option.getOr(location.country, "France")
    };
  });
}

let Formatter;

export {
  Formatter,
  supplierContactFromData,
  supplierLocationFromData,
}
/* SupplierCivility Not a pure module */
